// extracted by mini-css-extract-plugin
export default {"bone":"styles_bone__abcQw","bone-skeleton":"styles_bone-skeleton__BF+9z"};